import Loadable from "react-loadable";

const LazyMyCoopted = Loadable({
  loader: () => import(/* webpackChunkName: 'list-my-coopted' */ "./index"),
  loading: () => 'loading...'
});

export default LazyMyCoopted;
